import { CountUp } from "countup.js";
const typeOf = type => object => Object.prototype.toString.call(object) === `[object ${type}]`;
const isFunction = typeOf("Function");
export default {
  name: "VueCountUp",
  __countup__: CountUp,
  props: {
    delay: {
      type: Number,
      default: 0
    },
    endVal: {
      type: Number,
      required: true
    },
    options: {
      type: Object,
      default: () => ({})
    },
    useUnit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      instance: null
    };
  },
  watch: {
    endVal(value) {
      if (this.instance && isFunction(this.instance.update)) {
        this.instance.update(value);
      }
    }
  },
  methods: {
    formatWithUnit(value) {
      const units = [{
        value: 1e24,
        symbol: "Sp"
      }, {
        value: 1e21,
        symbol: "Sx"
      }, {
        value: 1e18,
        symbol: "Qn"
      }, {
        value: 1e15,
        symbol: "Q"
      }, {
        value: 1e12,
        symbol: "T"
      }, {
        value: 1e9,
        symbol: "B"
      }, {
        value: 1e6,
        symbol: "M"
      }, {
        value: 1e3,
        symbol: "K"
      }];
      for (const unit of units) {
        if (value >= unit.value) {
          const num = value / unit.value;
          const fixed = num.toFixed(2);
          return fixed.endsWith(".00") ? Math.round(num) + unit.symbol : parseFloat(fixed).toString() + unit.symbol;
        }
      }
      return this.formatWithThousandSeparator(value);
    },
    formatWithThousandSeparator(value) {
      const decimalPlaces = this.options && typeof this.options.decimalPlaces === "number" ? this.options.decimalPlaces : null;
      let num = Number(value);
      if (isNaN(num)) return value;
      if (decimalPlaces !== null) {
        num = parseFloat(num.toFixed(decimalPlaces));
      }
      return num.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: decimalPlaces ?? 8
      });
    },
    create() {
      if (this.instance) return;
      const dom = this.$el;

      // Clone options and inject formattingFn
      const options = Object.assign({}, this.options);
      options.formattingFn = num => {
        return this.useUnit ? this.formatWithUnit(num) : this.formatWithThousandSeparator(num);
      };
      const instance = new CountUp(dom, this.endVal, options);
      if (instance.error) {
        console.error(instance.error);
        return;
      }
      this.instance = instance;
      if (this.delay < 0) {
        this.instance.printValue(this.endVal);
        this.$emit("ready", instance, CountUp);
        return;
      }
      setTimeout(() => {
        instance.start(() => {
          this.$emit("ready", instance, CountUp);
        });
      }, this.delay);
    },
    destroy() {
      this.instance = null;
    },
    printValue(value) {
      if (this.instance && isFunction(this.instance.printValue)) {
        this.instance.printValue(value);
      }
    },
    start(callback) {
      if (this.instance && isFunction(this.instance.start)) {
        return this.instance.start(callback);
      }
    },
    pauseResume() {
      if (this.instance && isFunction(this.instance.pauseResume)) {
        return this.instance.pauseResume();
      }
    },
    reset() {
      if (this.instance && isFunction(this.instance.reset)) {
        return this.instance.reset();
      }
    },
    update(newEndVal) {
      if (this.instance && isFunction(this.instance.update)) {
        this.instance.update(newEndVal);
      }
    }
  },
  mounted() {
    this.create();
  },
  beforeDestroy() {
    this.destroy();
  }
};